<div>
  <!-- Create new order-->
  <mat-horizontal-stepper
    linear="true"
    #stepper
    (selectionChange)="onStepChange($event)"
  >
    <!-- Step 1 formulario-->
    <mat-step [stepControl]="formIF" label="Formulario">
      <ng-container *ngTemplateOutlet="formInspection"></ng-container>
    </mat-step>

    <!-- Step 2 asociar preguntas-->
    <mat-step label="Agregar Preguntas">
      <form [formGroup]="formQuestions" style="overflow: auto">
        <ng-template matStepLabel>Preguntas</ng-template>
        <div
          class="mt-4 d-flex flex-column flex-sm-row align-items-center justify-content-between"
        >
          <app-generic-question
            style="width: 100%"
            [cdkDragEnabled]="true"
            [showTitle]="false"
            [questionsBank]="false"
            [bodyQuestions]="bodyQuestions"
            (questionAdded)="addQuestions($event)"
            (formAccordingToVersion)="getFormAccordingToVersion()"
            (questionDeleted)="deleteQuestion($event)"
          >
          </app-generic-question>
        </div>
        <div
          style="display: flex; flex-direction: row; justify-content: center"
        >
          <button
            [disabled]="bodyQuestions.length == 0"
            type="button"
            style="width: 70%; margin-top: 30px; align-self: center"
            color="primary"
            class="button-save mat-elevation-z5"
            mat-raised-button
            (click)="formQuestions.valid ? stepper.next() : errorMessage()"
          >
            Aceptar
          </button>
        </div>
      </form>
    </mat-step>

    <!-- Step 3 asociar equipos-->
    <mat-step [stepControl]="formEquipment" label="Asociar Equipos">
      <form [formGroup]="formEquipment">
        <ng-template matStepLabel>Asociar Equipos</ng-template>
        <div style="width: 100%; padding: 10px">
          <data-table
            title=""
            [columns]="columnsEquiment"
            [configuration]="configurationEquipment"
            [reloadTable]="reloadTableEquipment"
            [params]="equipmentParams"
            [url]="
              EndpointDictionary.Equipment.EQUIPMENT_TABLE_BY_INSPECTION_FORM
            "
            (add)="addEquipments($event)"
            (delete)="deleteEquipment($event)"
          >
          </data-table>
        </div>
        <div
          style="display: flex; flex-direction: row; justify-content: center"
        >
          <button
            type="button"
            style="width: 70%; margin-top: 30px; align-self: center"
            color="primary"
            class="button-save mat-elevation-z5"
            mat-raised-button
            (click)="formEquipment.valid ? finalizar() : errorMessage()"
          >
            Finalizar
          </button>
        </div>
      </form>
    </mat-step>
  </mat-horizontal-stepper>

  <ng-template #formInspection>
    <form
      [formGroup]="formIF"
      (ngSubmit)="formIF.valid ? saveFormIF() : errorMessage()"
      style="overflow: auto"
    >
      <cdk-virtual-scroll-viewport itemSize="100" class="example-viewport cdk">
        <div style="display: flex; width: 100%; margin-top: 10px">
          <div [style.flex]="!inspectionForm ? 10 : 12">
            <div class="first-row">
              <div class="row-item">
                <mat-form-field>
                  <mat-label>Nombre</mat-label>
                  <input
                    autocomplete="off"
                    type="text"
                    formControlName="name"
                    matInput
                    required
                    #nombre
                    maxlength="255"
                    placeholder="Nombre"
                    (input)="onInputChange()"
                  />
                  <mat-hint>{{ nombre.value.length }}/255</mat-hint>
                </mat-form-field>
              </div>

              <div class="row-item">
                <mat-form-field>
                  <mat-label>Versión</mat-label>
                  <input
                    autocomplete="off"
                    type="text"
                    formControlName="version"
                    matInput
                    #version
                    maxlength="255"
                    placeholder="Versión"
                    (input)="onInputChange()"
                  />
                  <mat-hint>{{ version.value.length }}/45</mat-hint>
                </mat-form-field>
              </div>

              <div class="row-item">
                <mat-form-field>
                  <mat-label>Código</mat-label>
                  <input
                    autocomplete="off"
                    type="text"
                    formControlName="code"
                    matInput
                    #codigo
                    maxlength="255"
                    placeholder="Código"
                    (input)="onInputChange()"
                  />
                  <mat-hint>{{ codigo.value.length }}/45</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <div class="default-row">
              <div class="row-item">
                <combos
                  [configuration]="combosConfigPeriodicityType"
                  [reloadCombo]="reloadComboPeriodicityType"
                  [required]="true"
                  [filter]="true"
                  [control]="formIF.get('periodicityTypeId')"
                  (changeOption)="onInputChange()"
                >
                </combos>
              </div>

              <div class="row-item">
                <mat-form-field>
                  <mat-label>Periodicidad</mat-label>
                  <input
                    autocomplete="off"
                    type="number"
                    formControlName="periodicityValue"
                    matInput
                    required
                    #periodicidad
                    maxlength="255"
                    placeholder="Periodicidad"
                    min="1"
                    (input)="onInputChange()"
                  />
                  <mat-hint>{{ periodicidad.value.length }}/5</mat-hint>
                </mat-form-field>
              </div>

              <div class="row-item">
                <mat-form-field [appOpenDatepickerOnClick]="picker">
                  <mat-label>Fecha</mat-label>
                  <input
                    [matDatepicker]="picker"
                    autocomplete="off"
                    matInput
                    formControlName="dateFormat"
                    [disabled]="true"
                  />
                  <mat-datepicker-toggle matIconSuffix [for]="picker">
                  </mat-datepicker-toggle>
                  <mat-datepicker
                    #picker
                    [touchUi]="movil ? true : false"
                  ></mat-datepicker>
                </mat-form-field>
              </div>
            </div>

            <div class="default-row">
              <div class="row-item">
                <mat-form-field>
                  <mat-label>Descripción</mat-label>
                  <input
                    autocomplete="off"
                    type="text"
                    formControlName="description"
                    matInput
                    #descripcion
                    maxlength="255"
                    placeholder="Descripción"
                    (input)="onInputChange()"
                  />
                  <mat-hint>{{ descripcion.value.length }}/255</mat-hint>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <div
          style="display: flex; flex-direction: row; justify-content: center"
        >
          <button
            [disabled]="false"
            type="submit"
            style="width: 70%; margin-top: 30px; align-self: center"
            color="primary"
            class="button-save mat-elevation-z5"
            mat-raised-button
          >
            Aceptar
          </button>
        </div>
      </cdk-virtual-scroll-viewport>
    </form>
  </ng-template>
</div>
